export default {
  getSafe: (dataFunction, defaultValue = null) => {
    try {
      return dataFunction() || defaultValue;
    } catch (e) {
      return defaultValue;
    }
  },
};
